/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import ITemplateModel from 'apmui/master/Model';
import PAGE from 'apmui/page/PageType';
import { IResourceStore } from 'apmui/resource';
import INetworkAccessModel from './NetworkAccessModel';
import IVdiModel from './VdiModel';
import WebtopType from './WebtopType';

interface IWebtopSectionConfig {
    /** Captions for standard sections */
    applicationLinksCaption: string;
    networkAccessCaption: string;
    fallbackCaption: string;

    /** Section icons */
    expandImage: string;
    shrinkImage: string;
}

interface IWebtopUrlInputConfig {
    /** toolbar with URL input */
    enabled: string;
    title: string;
}

interface IWebtopSearchConfig {
    /** Search icons and strings */
    enabled: string;
    onImage: string;
    offImage: string;
    title: string;
    resourceNotFoundCaption: string;
}

interface IWebtopConfig {
    type: WebtopType;
    section: IWebtopSectionConfig;
    urlInput: IWebtopUrlInputConfig;
    search: IWebtopSearchConfig;
}

interface IWebtopTimeoutDialogConfig {
    header: string;
    stayConnectedCaption: string;
    disconnectCaption: string;
    messagePrefix: string;
    messageSecondsPrefix: string;
    messageSecondsPostfix: string;
    messagePostfix: string;
}

interface IWebtopTimeoutConfig {
    /** session timeout strings: */
    /** dialog without max session time */
    dialog: IWebtopTimeoutDialogConfig;
    /** dialog with max session time */
    dialogMax: IWebtopTimeoutDialogConfig;
}

interface IWebtopModel extends ITemplateModel {
    pageType: PAGE.WEBTOP;
    [PAGE.WEBTOP]: {
        /** Storage for webtop resources */
        resources?: IResourceStore;

        /** Current folder in folder browser */
        activeFolder?: string;

        /** General webtop strings and configuration */
        config: IWebtopConfig;

        /* Network Access state, strings and customizations */
        network_access: INetworkAccessModel;

        /** TODO: Prepare UI beter */
        vdi: IVdiModel;

        /** Strings for session timeout */
        timeout: IWebtopTimeoutConfig;
    };
}

export interface IWebtopResourceUpdate {
    resources?: IResourceStore;
}

export {
    IWebtopModel as default,
    IWebtopModel,
    IWebtopConfig,
    IWebtopSearchConfig,
    IWebtopSectionConfig,
    IWebtopTimeoutConfig,
    IWebtopTimeoutDialogConfig,
    IWebtopUrlInputConfig,
};
